// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container{max-width:1185px}}.w-page-login,.w-page-password_reset_confirmation,.w-page-register{max-width:700px}.w-volume-controller{position:relative}.w-volume-controller__popover{max-width:380px}.w-volume-controller__slider{width:200px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
